module.exports = __webpack_public_path__ + "static/media/email.2ec28135.svg";